import React from "react";

import "./services.scss";

export class ServicesPage extends React.Component<any, any> {
  render() {
    return (
      <div className="container">
        <div className="our-service">
          <span className="our-service__subtitle">Наши услуги</span>
          <span className="our-service__title">
            Возьмем на себя заботы о вашем бизнесе
            <span className="blink">_</span>
          </span>
          <span className="out-service__subtext">
            Colorite поможет визуализировать даже самые сумасшедшие идеи,
            превратив их в колоритный дизайн с уникальными <br /> особенностями.
            Поможем привлечь клиентов из интернета и повысить узнаваемость
            вашего бренда.
          </span>
          <div className="service">
            <div className="service__card">
              <svg
                width="77"
                height="67"
                viewBox="0 0 77 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.3292 14.084C9.33625 14.084 7.71985 12.4621 7.71985 10.4624C7.71985 8.46206 9.33625 6.84082 11.3292 6.84082C13.3228 6.84082 14.9386 8.46206 14.9386 10.4624C14.9386 12.4621 13.3228 14.084 11.3292 14.084ZM22.1573 14.084C20.1644 14.084 18.548 12.4621 18.548 10.4624C18.548 8.46206 20.1644 6.84082 22.1573 6.84082C24.1509 6.84082 25.7667 8.46206 25.7667 10.4624C25.7667 12.4621 24.1509 14.084 22.1573 14.084ZM32.9855 14.084C30.9925 14.084 29.3761 12.4621 29.3761 10.4624C29.3761 8.46206 30.9925 6.84082 32.9855 6.84082C34.979 6.84082 36.5948 8.46206 36.5948 10.4624C36.5948 12.4621 34.979 14.084 32.9855 14.084ZM0 0H77V57.9453H73.3906V3.62109H3.60938V54.3242H26.4688V23.5405H69.7812V67H26.4688V57.9453H0V0ZM34.8906 39.8374H61.3594V36.2158H34.8906V39.8374ZM34.8906 47.0806H61.3594V43.4595H34.8906V47.0806ZM34.8906 54.3242H61.3594V50.7026H34.8906V54.3242Z"
                  fill="#EE6C0E"
                />
              </svg>
              <span>Создание сайтов</span>

              <ul>
                <li>Разработаем сайт для бизнеса</li>
                <li>Оптимизируем для поисковиков (SEO)</li>
                <li>Поможем с поддержкой и развитием</li>
              </ul>
            </div>
            <div className="service__card">
              <svg
                width="50"
                height="64"
                viewBox="0 0 50 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M33.9286 48.3018C36.5583 48.3018 38.6905 50.4644 38.6905 53.1318C38.6905 55.7993 36.5583 57.9624 33.9286 57.9624C31.2988 57.9624 29.1667 55.7993 29.1667 53.1318C29.1667 50.4644 31.2988 48.3018 33.9286 48.3018ZM50 38.6416H46.4286V15.0942H35.119V3.62256H3.57144V54.3398H17.8571V42.2642H50V64H17.8571V57.9624H3.57144H0V3.62256V0H3.57144H35.119L50 15.0942V38.6416ZM21.4286 13.2832C21.4286 15.9507 19.2964 18.1133 16.6667 18.1133C14.0369 18.1133 11.9048 15.9507 11.9048 13.2832C11.9048 10.6157 14.0369 8.45264 16.6667 8.45264C19.2964 8.45264 21.4286 10.6157 21.4286 13.2832ZM11.9048 31.396V27.7734H38.0952V31.396H11.9048ZM11.9048 38.6416V35.019H38.0952V38.6416H11.9048Z"
                  fill="#EE6C0E"
                />
              </svg>
              <span>Разработка дизайна</span>

              <ul>
                <li>Фирменный стиль</li>
                <li>Создание бренда</li>
                <li>Маркетинговые материалы</li>
              </ul>
            </div>
            <div className="service__card">
              <svg
                width="58"
                height="58"
                viewBox="0 0 58 58"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.431396 57.3774V0.622681H57.5686V57.3774H0.431396ZM4.00308 53.8296H53.997V4.17045H4.00308V53.8296ZM43.2843 21.9057L29 50.2831V36.0944H14.7157L29 7.71702V21.9057H43.2843Z"
                  fill="#EE6C0E"
                />
              </svg>

              <span>Продвижение бизнеса</span>

              <ul>
                <li>Таргетированная реклама</li>
                <li>Маркетинг в социальных сетях</li>
                <li>Контекстная реклама</li>
              </ul>
            </div>
          </div>
          <button>
            Смотреть все услуги
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99999 18.9999C9.76634 19.0004 9.5399 18.919 9.35999 18.7699C9.25873 18.686 9.17503 18.5829 9.11368 18.4665C9.05233 18.3502 9.01453 18.2229 9.00245 18.0919C8.99038 17.9609 9.00426 17.8289 9.0433 17.7033C9.08235 17.5777 9.14579 17.461 9.22999 17.3599L13.71 11.9999L9.38999 6.62994C9.30692 6.52765 9.24489 6.40996 9.20746 6.28362C9.17003 6.15728 9.15794 6.02479 9.17187 5.89376C9.18581 5.76273 9.22551 5.63575 9.28868 5.52011C9.35186 5.40447 9.43726 5.30246 9.53999 5.21994C9.64346 5.1289 9.76462 5.06024 9.89588 5.01825C10.0271 4.97626 10.1657 4.96185 10.3028 4.97594C10.4399 4.99002 10.5726 5.03229 10.6925 5.1001C10.8125 5.1679 10.9172 5.25977 11 5.36994L15.83 11.3699C15.9771 11.5489 16.0575 11.7733 16.0575 12.0049C16.0575 12.2366 15.9771 12.461 15.83 12.6399L10.83 18.6399C10.7297 18.761 10.6022 18.8566 10.458 18.9192C10.3138 18.9817 10.1569 19.0094 9.99999 18.9999Z"
                fill="#333333"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}
